import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import api from '../api';
import Nav from '../components/Nav';
import Chat from '../components/Chat';

function DayView() {
  const { date } = useParams();
  const navigate = useNavigate();
  const [entry, setEntry] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/public/days/${date}`)
      .then(({ data }) => setEntry(data.entry))
      .catch(() => setEntry(null))
      .finally(() => setLoading(false));
  }, [date]);

  if (loading) return <div className="loading">...</div>;

  if (!entry) return (
    <div>
      <Nav active="days" />
      <div className="page">
        <div className="empty">
          <h2>This day is silent</h2>
          <p>Nothing was written here. Maybe it was lived instead.</p>
          <button className="btn btn-soft" onClick={() => navigate('/days')}>Back to timeline</button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Nav active="days" />
      <div className="page">
        <article className="entry-page">
          <div className="entry-date-big">
            {format(new Date(entry.entry_date.split('T')[0] + 'T00:00:00'), 'EEEE, MMMM d, yyyy')}
          </div>

          <div className="day-meta" style={{ justifyContent: 'center', marginBottom: '40px' }}>
            {entry.mood && <span className="badge badge-mood">{entry.mood}</span>}
            {entry.weather && <span className="badge badge-weather">{entry.weather}</span>}
            {entry.song && <span className="badge badge-tag">{entry.song}</span>}
          </div>

          <div className="entry-content-full">{entry.content}</div>

          <div className="entry-footer">
            <button className="btn btn-ghost" onClick={() => navigate('/days')}>
              &larr; All days
            </button>
          </div>
        </article>
      </div>
      <Chat contextType="day" contextDate={date} />
    </div>
  );
}

export default DayView;
